export * from './pie-chart.module';
export * from './pie-chart.component';
export * from './pie-arc.component';
export * from './pie-grid.component';
export * from './pie-series.component';
export * from './pie-label.component';
export * from './pie-series.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/pie-chart/index.js
// module id = ../../../../@swimlane/ngx-charts/release/pie-chart/index.js
// module chunks = 4